export enum StatusID {
    FAILED = 1,
    NEW = 2,
    MANDATE_CLOSED = 3,
    DATA_EXISTS = 4,
    DUPLICATE = 5
}

export const StatusName = {
    [StatusID.FAILED]: "Failed",
    [StatusID.NEW]: "New / not mapped",
    [StatusID.MANDATE_CLOSED]: "Mandate closed",
    [StatusID.DATA_EXISTS]: "Data exists",
    [StatusID.DUPLICATE]: "Duplicate"
};